import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface ConfirmationModalModalProps {
  title: string
  description: string
  submitText: string
  closeModal: () => void
  handleSubmit: () => void
}

const ConfirmationModal = ({
  closeModal,
  handleSubmit,
  title,
  description,
  submitText,
}: ConfirmationModalModalProps) => {
  return (
    <Modal
      illustration="alert"
      title={title}
      description={description}
      onSubmit={handleSubmit}
      onClose={closeModal}
      footer={
        <>
          <Button type="secondary" onClick={closeModal}>
            {i18n.t('common.close')}
          </Button>
          <Button submit>{submitText}</Button>
        </>
      }
    />
  )
}

export default ConfirmationModal
